import React from "react";
import { FiX, FiTag } from "react-icons/fi";
import classes from "./ViewBrandModal.module.css";
import { TbBrandDatabricks } from "react-icons/tb";

export default function ViewBrandModal({ brand, onClose }) {
  if (!brand) return null;

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={classes.header}>
          <h2>Brand Details</h2>
          <button className={classes.closeBtn} onClick={onClose}>
            <FiX size={22} />
          </button>
        </div>

        {/* Content */}
        <div className={classes.content}>
          {/* Brand Icon & Name */}
          <div className={classes.infoCard}>
            <TbBrandDatabricks className={classes.icon} />
            <div className={classes.textGroup}>
              <span>Brand Name</span>
              <p>{brand.brandName}</p>
            </div>
          </div>

          {/* Slug */}
          <div className={classes.infoCard}>
            <FiTag className={classes.icon} />
            <div className={classes.textGroup}>
              <span>Slug</span>
              <p>{brand.brand_slug}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={classes.footer}>
          <button className={classes.closeFooterBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
